import React from 'react';
import gravatar from '../../../assets/images/gravatar.png'
export default function e27MCPayment(){
  return(
   <div className="post-1477 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
<div className="blog-single-post nosidebar">

  <section className="subpage-banner mcpayment_two-banner"></section>

  <div className="container">

    <div className="row">

      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
                      
            <img src={gravatar} className="author-avatar img-circle img-responsive" alt="Avatar" />            
                                  

          </div>          

          <div className="col-sm-10">

            <h2 className="post-title">Thailand’s 2W Group leads S$5M investment into MC Payment to finance expansion</h2>
            <div className="row meta-info">
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-clock"></i>1 November 2016</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-comments"></i>No Comments</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-eye"></i>187 Views</span></div>
                            <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-tag"></i><a href="/news/" rel="category tag">News</a></span></div>
                          </div>

            <div className="post-article"><p>(Nov 2016:https://e27.co/thailands-2w-group-invests-us5m-into-singapores-mc-payment-to-help-it-expand-into-country-20161111/)</p>
<p>MC Payment, an omni-channel payments solution based in Singapore, announced today it has raised a S$5 million strategic investment round from a Thailand investment firm named 2W Group.</p>
<p>The 2W Group Managing Director is&nbsp;Schwin&nbsp;Chiaravanont, a member of the Chearavanont family (whose ownership of the Charoen Pokhphand Group makes them one of Thailand’s richest families).</p>
<p>Other participants in the round were&nbsp;Aura Funds Management, tryb Capital and Perle Ventures.</p>
<p>MC Payments&nbsp;also announced today its official launch in Thailand. A major priority for the investment will be growing the company’s presence in that market.</p>
<p>MC Payment also has plans to expand to Malaysia, Australia and Hong Kong as well as use the money to strengthen its Singapore operations. The company recently opened an office in Bali, Indonesia and will focus on merchant acquisition in that region.</p>
<p>Finally, MC Payment said it will use the funds to pursue acquisitions and strategic investments into other companies.</p>
<p>“We are excited to partner with 2W Group to enter Thailand, and are honoured to be a part of the National e-Payment Master Plan that aims to build a cashless society. We hope that this enhances our vision of becoming the region’s foremost omni-channel payments technology and solutions provider,” said MC Payment Founder and Group CEO Anthony Koh in an official statement.</p>
<p>MC Payments refers to itself as both a payment provider and merchant service that focusses on non-cash transactions and&nbsp;facilitates both online and offline channels. It has solutions for traditional credit cards, contactless payments, smartphone/tablet gateways and a digital wallet feature.</p>
</div>

            <hr></hr>
            
            <div className="social-share">
              <div className="row">
                <div className="col-xs-6 share-text">Share</div>
                <div className="col-xs-6 share-button">
                  <div className="btn-group">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                    <a href="https://plus.google.com/share?url=https://33-capital.com/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-gplus"></i></a>
                    <a href="https://twitter.com/intent/tweet?text=Thailand’s 2W Group leads S$5M investment into MC Payment to finance expansion&amp;url=https://33-capital.com/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-twitter"></i></a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/&amp;title=Thailand’s 2W Group leads S$5M investment into MC Payment to finance expansion&amp;summary=(Nov 2016:https://e27.co/thailands-2w-group-invests-us5m-into-singapores-mc-payment-to-help-it-expand-into-country-20161111/) MC Payment, an omni-channel payments solution based in Singapore, announced today it has raised a S$5 million strategic investment round from a Thailand investment firm named 2W Group. The 2W Group Managing Director is Schwin Chiaravanont, a member of the Chearavanont family (whose ownership of the Charoen Pokhphand Group makes them one of Thailand’s richest&amp;source=https://33-capital.com/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a>
                    <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion/&amp;description=(Nov 2016:https://e27.co/thailands-2w-group-invests-us5m-into-singapores-mc-payment-to-help-it-expand-into-country-20161111/) MC Payment, an omni-channel payments solution based in Singapore, announced today it has raised a S$5 million strategic investment round from a Thailand investment firm named 2W Group. The 2W Group Managing Director is Schwin Chiaravanont, a member of the Chearavanont family (whose ownership of the Charoen Pokhphand Group makes them one of Thailand’s richest&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest"></i></a>
                  </div>                  
                </div>
              </div>
            </div>  
            <hr></hr>
                        <div className="comment-count">
              No Comments           </div>
            <hr></hr>
                        
          </div>
        
        </div>
       
      
      </div>

  

    </div>

  </div>

</div>
</div>

  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/e27_mcpayment.js